import Vue from 'vue';
import Vuex, { Module } from 'vuex';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';
import { RootState } from '@/store';
import { Grid } from '@/models/Grid.model';
import { ApplicationUserInfoModel } from '@/models/backoffice/ApplicationUserInfoModel';
import { ApplicationUserAdditionalInfoModel } from '@/models/backoffice/ApplicationUserAdditionalInfoModel';
import { ApplicationUserSearchModel } from '@/models/backoffice/ApplicationUserSearchModel';
import { UserDetails } from '@/models/UserDetails.model';

Vue.use(Vuex);

export interface ApplicationUserState {
  applicationUserInfoErrors: string[];
  applicationUserLoading: boolean;
  userInfoList: Grid<ApplicationUserInfoModel>;
  userAdditionalInfoList: Grid<ApplicationUserAdditionalInfoModel>;
  applicationUserSearchObject: ApplicationUserSearchModel;
  currentAppUserDetails: UserDetails;
  openChangeAppUserDetailsModal: boolean;
  changeAppUserDetailsModalErrors: string[];
}

// message state model init
export const initialState = (): ApplicationUserState => {
  return {
    applicationUserInfoErrors: [],
    applicationUserLoading: false,
    userInfoList: {} as Grid<ApplicationUserInfoModel>,
    userAdditionalInfoList: {} as Grid<ApplicationUserAdditionalInfoModel>,
    applicationUserSearchObject: {} as ApplicationUserSearchModel,
    currentAppUserDetails: {} as UserDetails,
    openChangeAppUserDetailsModal: false,
    changeAppUserDetailsModalErrors: [],
  };
};

export const applicationUser: Module<ApplicationUserState, RootState> = {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
